import React, { useEffect } from 'react'
import Card from "../../../../assets/ReEngageFollowup/img/card.png";
import icon1 from "../../../../assets/ReEngageFollowup/img/ic1.jpg";
import icon2n from "../../../../assets/ReEngageFollowup/img/ic2n.jpg";
import icon3 from "../../../../assets/ReEngageFollowup/img/ic3n.jpg";
import icon2 from "../../../../assets/ReEngageFollowup/img/ic2.jpg";
import icon4 from "../../../../assets/ReEngageFollowup/img/ic4.png";
import icon5 from "../../../../assets/ReEngageFollowup/img/ic5.png";
import icon6 from "../../../../assets/ReEngageFollowup/img/ic6.png";
import s1 from "../../../../assets/ReEngageFollowup/img/s1.png";
import s2 from "../../../../assets/ReEngageFollowup/img/s2.png";
import s3 from "../../../../assets/ReEngageFollowup/img/s3.png";
import Header from './Header';
import AccordSection from './Accordion';
import Footer from './Footer';
import HeaderTop from './HeaderTop';
import "../../../../assets/ReEngageFollowup/scss/modules/custom.scss";

const CC_intro = ({ userDetails, onContinue, pageStatus }) => {

    const maskCardNumber = (cardNumber) => {
        if (!cardNumber) return 'XXXX0000';
        const cardStr = cardNumber.toString();
        const lastFourDigits = cardStr.slice(-4).padStart(4, '0');
        return `XXXX${lastFourDigits}`;
    };

    const formatDateOnly = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toISOString().split('T')[0]; // Returns YYYY-MM-DD format
    };

    const masked_card_num = maskCardNumber(userDetails.card_number);
    const mgrade1 = userDetails.module_grade_1;
    const mgrade2 = userDetails.module_grade_2;
    const mgrade3 = userDetails.module_grade_3;
    const mgrade4_5 = userDetails.final_grade;

    useEffect(() => {
        (async () => {
            await pageStatus({
                uuid: userDetails.uuid,
                page_name: "re_engage_cc_intro",
                status: "visited",
                source: userDetails.followup_data?.atp_sub6,
                re_engaged_id: userDetails.re_engaged_id,
            });
        })();
    }, []);

    const slideChange = async (e) => {
        await pageStatus({
            uuid: userDetails.uuid,
            page_name: "re_engage_cc_intro",
            status: "completed",
            source: userDetails.followup_data?.atp_sub6,
            re_engaged_id: userDetails.re_engaged_id,
        });
        onContinue(e);
    };

    return (
        <>
            <div className="reengage-followup">
                <HeaderTop userDetails={userDetails} />
                <Header />
                <main className="hero">
                    <div className="container">
                        <div className="row align-items-center gx-lg-5 pt-2">
                            {/* TEXT */}
                            <div className="col-lg-7">
                                <div className="hero__text">
                                    <p className="hero__desc"><strong> {userDetails.user_fullname}, our credit file analysis revealed further potential claims that appear to have merit.</strong></p>
                                    <table className="table custom-table mt-1 mb-3 ">
                                        <tbody>
                                            <tr>
                                                <td className="data-label">Lender:</td>
                                                <td className="data-value">{userDetails.tms_display_name}</td>
                                            </tr>
                                            <tr>
                                                <td className="data-label">Account No:</td>
                                                <td className="data-value">{masked_card_num}</td>
                                            </tr>
                                            <tr>
                                                <td className="data-label">Account Opened:</td>
                                                <td className="data-value">{formatDateOnly(userDetails.account_startdate)}</td>
                                            </tr>
                                            <tr>
                                                <td className="data-label">Product:</td>
                                                <td className="data-value">Credit Card</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div className="custom-bullet-list mb-2">
                                        <ul>
                                            {mgrade1 == "Yes" && <li>High/very high utilisation for long periods</li>}
                                            {mgrade2 == "Yes" && <li>Missed/arrears/default markers</li>}
                                            {mgrade3 == "Yes" && <li>Persistent minimum payments</li>}
                                            {mgrade4_5 == "Yes" && <li>Cash advances / reliance on cash withdrawals</li>}
                                        </ul>
                                    </div>
                                    <p className="hero__desc_impo mb-0">
                                        Highest Refund - <strong> £37,370</strong><br />
                                        Average Refund - <strong> £2,483<sup>*</sup></strong>
                                    </p>

                                    {/* DESKTOP CTA */}
                                    <button onClick={slideChange} value="Instruct TMS to start my claim" className="btn btn-claim btn-lg d-none d-lg-block zoom-in-zoom-out btn-custom">Instruct TMS to start my claim &gt;
                                    </button>
                                    {/* <div className="pt-2 d-none d-lg-block fnt-size15">
                                        <span>Instruct TMS to claim for your Lloyds Credit card</span>
                                    </div> */}
                                </div>
                            </div>
                            {/* IMAGE */}
                            <div className="col-lg-5 col-12">
                                <div className="hero__art text-center text-lg-end d-none d-lg-block">
                                    <img src={Card} className="hero__card" alt="credit card illustration" />
                                </div>
                                {/* MOBILE CTA */}
                                <div className="text-center mt-3 d-lg-none">
                                    <button onClick={slideChange} value="Instruct TMS to start my claim" className="btn btn-claim btn-lg w-100 zoom-in-zoom-out">Instruct TMS to start my claim &gt;
                                    </button>
                                </div>
                                {/* <div className="text-center pt-1 d-lg-none fnt-size15">
                                    <span>Instruct TMS to claim for your Lloyds Credit card</span>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </main>

                <section className="why-claim">
                    <div className="container text-center">
                        <h2 className="why-claim__title">Why we reached out</h2>
                        <h3 className="why-claim__subtitle">We found one or more of:</h3>
                        <div className="why-claim__grid">
                            {/* item 1 */}
                            <div className="why-claim__item">
                                <img src={icon1} className="why-claim__icon" />
                                <p className="why-claim__text">
                                    High/very high utilisation for long periods
                                </p>
                            </div>
                            {/* item 2 */}
                            <div className="why-claim__item">
                                <img src={icon2n} className="why-claim__icon" alt="Refund" />
                                <p className="why-claim__text">
                                    Missed/arrears/default markers
                                </p>
                            </div>
                            {/* item 3 */}
                            <div className="why-claim__item">
                                <img src={icon3} className="why-claim__icon" alt="Quick" />
                                <p className="why-claim__text">
                                    Persistent minimum payments
                                </p>
                            </div>
                            {/* item 4 */}
                            <div className="why-claim__item">
                                <img src={icon2} className="why-claim__icon" alt="Quick" />
                                <p className="why-claim__text">
                                    Cash advances/reliance on cash withdrawals
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="how-works">
                    <div className="container text-center">
                        <h2 className="how-works__title">How It Works</h2>
                        <div className="row justify-content-center g-4 g-md-5 how-works__row">
                            <div className="col-10 col-sm-6 col-md-4">
                                <div className="how-works__item">
                                    <img src={icon4} className="how-works__icon" alt="Pick up" />
                                    <p className="how-works__text">Pick up where you left off</p>
                                </div>
                            </div>
                            <div className="col-10 col-sm-6 col-md-4">
                                <div className="how-works__item">
                                    <img src={icon5} className="how-works__icon" alt="Short questions" />
                                    <p className="how-works__text">Answer a couple of short questions</p>
                                </div>
                            </div>
                            <div className="col-10 col-sm-6 col-md-4">
                                <div className="how-works__item">
                                    <img src={icon6} className="how-works__icon" alt="Eligibility" />
                                    <p className="how-works__text">We’ll check your eligibility instantly</p>
                                </div>
                            </div>
                        </div>
                        <button onClick={slideChange} value="Get Started Again" className="btn btn-claim how-works__cta">
                            Get Started Again <span className="btn-arrow">→</span>
                        </button>
                    </div>
                </section>
                <section className="trust py-5">
                    <div className="container">
                        <h2 className="trust__title text-center mb-4">Trust &amp; Reassurance</h2>
                        {/* row 1: two small cards */}
                        <div className="row g-4 mb-2">
                            <div className="col-6">
                                <figure className="trust-card trust-card--square">
                                    <img src={s1} alt="Secure process" className="trust-card__img" />
                                </figure>
                                <p className="trust__caption">Secure process backed by TMS</p>
                            </div>
                            <div className="col-6">
                                <figure className="trust-card trust-card--square">
                                    <img src={s2} alt="No cost to check" className="trust-card__img" />
                                </figure>
                                <p className="trust__caption">No cost to check</p>
                            </div>
                        </div>
                        {/* row 2: big wide card */}
                        <div className="row g-4">
                            <div className="col-12">
                                <figure className="trust-card trust-card--wide mb-2">
                                    <img src={s3} alt="You're halfway there" className="trust-card__img" />
                                </figure>
                                <p className="trust__caption">You’re already halfway there</p>
                            </div>
                        </div>
                        <div className="text-center mt-4">
                            <button onClick={slideChange} value="Complete My Claim" className="btn btn-claim btn-lg trust__cta">
                                Complete My Claim <span className="btn-arrow">→</span>
                            </button>
                        </div>
                    </div>
                </section>
                <section className="benefits">
                    <div className="container">
                        <div className="benefits__grid">
                            {/* Item 1 */}
                            <div className="benefits__item text-center">
                                <div className="benefits__icon">
                                    <i className="bi bi-arrow-counterclockwise" />
                                </div>
                                <h3 className="benefits__title">
                                    Get your Mis-sold credit<br />card Fees and Charges back
                                </h3>
                                <p className="benefits__desc">
                                    Many credit cards were not sold properly.
                                    You could claim back the fees and charges
                                    plus 8% interest.
                                </p>
                            </div>
                            {/* Item 2 */}
                            <div className="benefits__item text-center">
                                <div className="benefits__icon">
                                    <i className="bi bi-person-gear" />
                                </div>
                                <h3 className="benefits__title">
                                    Your Claim Fought by<br />Financial &amp; Legal Experts
                                </h3>
                                <p className="benefits__desc">
                                    We're ahead of the field, drawing on years of
                                    financial services and legal expertise for a
                                    strong claim.
                                </p>
                            </div>
                            {/* Item 3 */}
                            <div className="benefits__item text-center">
                                <div className="benefits__icon">
                                    <i className="bi bi-shield-plus" />
                                </div>
                                <h3 className="benefits__title">
                                    Respecting Your<br />Information Security
                                </h3>
                                <p className="benefits__desc">
                                    We take security very seriously and follow
                                    the rules of the Data Protection Act.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <AccordSection />
                <Footer />
            </div>
        </>
    )
}

export default CC_intro